import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import SEventList from "./SEventList";
import SSpikerBoard from "./SSpikerBoard";
import SNoPage from "./SNoPage";

export default function Home() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/">
                    <Route index element={<SEventList />} />
                    <Route path="/spikerBoard/:eventid" element={<SSpikerBoard />} />
                    <Route path="*" element={<SNoPage />} />
                </Route>
            </Routes>
        </BrowserRouter>
    )
}